import { render } from "./LateFees.vue?vue&type=template&id=701e0eb2&scoped=true"
import script from "./LateFees.vue?vue&type=script&lang=js"
export * from "./LateFees.vue?vue&type=script&lang=js"

import "./LateFees.vue?vue&type=style&index=0&id=701e0eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701e0eb2"]])

export default __exports__